import { enTranslations } from '@sbercloud/common-translations';
export var en_GB = {
  ErrorPage: {
    frontendErrorTitle: 'Unexpected error',
    pageUnavailableTitle: 'Service unavailable',
    pageNotFoundTitle: 'Page not found',
    refreshButton: 'Refresh the page',
    actionRedirectTitle: 'Try starting from another page',
    supportCenterButton: 'Support Service',
    mainPageLink: 'Go to the main page',
    backLink: 'Go back',
    offlineTitle: 'No Internet Connection',
    offlineText: 'Check your internet connection and try refreshing the page',
    redirectTitle: 'The link will be removed',
    redirectText: 'The link is obsolete and will be removed soon. Go to the new link',
    redirectButton: 'Go to'
  },
  FieldsPredefined: {
    SelectCreate: {
      buttonCreate: 'Create',
      buttonCancel: 'Cancel',
      buttonRefetch: 'Refetch',
      selectPlaceholder: 'Select option',
      noData: 'not found',
      noResult: 'not found',
      loadError: 'Error occurred while loading',
      changeRequest: 'Change request or create'
    },
    FieldPhone: {
      russia: 'Russia',
      belarus: 'Belarus',
      kazakhstan: 'Kazakhstan',
      armenia: 'Armenia',
      kyrgyzstan: 'Kyrgyzstan',
      uzbekistan: 'Uzbekistan',
      azerbaijan: 'Azerbaijan',
      tajikistan: 'Tajikistan',
      georgia: 'Georgia'
    }
  },
  Header: {
    headerProjectSelectorCreateProject: 'Create project',
    headerProjectSelectorCreateWorkspace: 'Create workspace',
    headerProjectSelectorEditOption: 'Edit',
    noDataFound: 'Nothing found',
    // ЛК 2.0
    menu: 'Menu',
    navigation: 'Navigation',
    searchByServices: 'Search by service',
    noData: 'No data',
    notifications: 'Notifications',
    notificationsAll: 'All',
    notificationsUnread: 'Unread',
    markAllAsRead: 'Mark all as read',
    noNotificationsTitle: 'No notifications',
    noNotificationsDescription: "This is where you'll see new event notifications when something happens",
    notificationsErrorTitle: "We're already fixing it",
    notificationsErrorDescription: 'Your notifications will appear here soon',
    notificationsDivider: 'Already read',
    notificationsFooterButton: 'All events',
    search: 'Search',
    searchCloseButton: 'Close search',
    searchOpenButton: 'Open search',
    edit: 'Edit',
    organizations: 'Organizations',
    addOrganization: 'Add organization',
    organizationNewBadge: 'New',
    partnerOrganizationBadge: 'Partner',
    invitePopoverTitle: 'A different organization is now available to you',
    invitePopoverText: 'You can change your organization by clicking on your profile',
    invitePopoverAcceptButton: 'Change now',
    invitePopoverCancelButton: 'Cancel',
    projects: 'Projects',
    addProject: 'Add projects',
    platforms: 'Platforms',
    manageProfile: 'Manage profile',
    switchTheme: 'Switch theme',
    logout: 'Logout',
    whatsNew: "What's new",
    workspaces: 'Workspaces',
    requestAccessWorkspaces: 'No access to project workspaces',
    requestAccessWorkspacesLabel: 'Request',
    addWorkspace: 'Add workspace',
    favorite: 'Favorite',
    financialMenuTitle: 'Budget control',
    financialMenuToSection: 'To section',
    financialMenuEyeButtonDataVisibleTip: 'Hide balance in header',
    financialMenuEyeButtonDataHiddenTip: 'Show balance in header',
    financialMenuBonusSign: 'B',
    financialMenuTooltipMoreButton: 'More details',
    financialMenuBalanceAction: 'Top up the balance',
    financialMenuBonusesAction: 'Enter promo code',
    financialMenuBonusesDisabledTip: 'Top up your balance. To activate the promo code, your balance must be positive.',
    financialMenuGrantInfinity: 'without a statute',
    financialMenuNoGrants: 'No grants yet',
    financialMenuGrantStatusSpending: 'Spending',
    financialMenuGrantStatusNotSpending: 'Not spending',
    financialMenuGrantStatusNotStart: 'No expiration date yet',
    financialMenuAddServicesLink: 'Connect services',
    financialMenuGetGrant: 'Get an initial grant',
    financialMenuGrantIsOnTheWay: 'The initial grant is on the way',
    financialMenuStarterGrantName: 'All services, without GPU',
    project: 'Project',
    workspace: 'Workspace',
    organization: 'Organization',
    searchProjectsPlaceholder: 'Search by projects',
    searchWorkspacesPlaceholder: 'Search by workspaces',
    themeModeLight: 'Light',
    themeModeDark: 'Dark',
    themeModeSystem: 'System',
    themeModeLabel: 'Interface Theme',
    partnerPopoverTitle: 'New organization available',
    partnerPopoverText: 'The application for participation in the referral program has been approved',
    partnerPopoverDescription: 'Switch to this organization to start working in the partner account. You can switch between organizations in your profile or in the project selection menu.',
    partnerPopoverCancelButton: "Don't show again",
    mkpBannerTitle: 'Marketplace',
    mkpBannerText: 'For development, data analysis and other tasks.',
    mkpBannerCount: '120+ services',
    referralBannerTitle: 'Referral program',
    referralBannerText: 'Earn up to 20% on recommendations of Cloud.ru services',
    referralBannerTag: '20%'
  },
  InfoRow: {
    booleanValueTrue: 'Yes',
    booleanValueFalse: 'No'
  },
  Layout: {
    noAccessTitle: 'Access restricted',
    noAccessSubtitle: "You don't have rights to view this content.",
    noAccessText: 'To gain access, contact the administrator of the organization or project'
  },
  MobileChips: {
    selectedN: 'Selected: ',
    resetAll: 'Reset All',
    select: 'Select'
  },
  MobileFields: {
    selectedN: 'Selected: ',
    resetAll: 'Reset All',
    select: 'Select'
  },
  MobileLayout: {
    "continue": 'Continue',
    create: 'Create',
    save: 'Save',
    cancel: 'Cancel',
    back: 'Back',
    rent: 'Rent',
    send: 'Send',
    add: 'Add',
    restore: 'Restore'
  },
  MobileToaster: {
    closeAll: 'Close all',
    showLess: 'Collapse',
    showMore: 'Expand'
  },
  ModalPredefined: {
    title: 'Delete',
    recallTitle: 'Withdrawal of application',
    fieldLabel: 'To do this, enter:',
    recallFieldLabel: 'To withdraw your request, enter:',
    enterName: 'Enter a name',
    required: 'Field must be filled',
    invalidName: 'Invalid name',
    cancel: enTranslations.buttons.cancel,
    "delete": 'Delete',
    recall: 'Recall',
    whatsNew: "What's new",
    readLater: 'Read later',
    outOf: 'of',
    noDataTitle: 'No news yet',
    noDataDescription: 'Platform news will be here soon',
    dataErrorTitle: 'Could not load data',
    dataErrorDescription: 'Try to refresh the page',
    dataErrorAction: 'Refresh'
  },
  PageLayout: {
    PageForm: {
      "continue": enTranslations.buttons["continue"],
      create: enTranslations.buttons.create,
      save: enTranslations.buttons.save,
      cancel: enTranslations.buttons.cancel,
      back: enTranslations.buttons.back,
      rent: enTranslations.buttons.rent,
      send: enTranslations.buttons.send,
      restore: enTranslations.buttons.restore,
      add: 'Add'
    },
    PageSidebar: {
      backTo: 'Back to',
      documentation: 'Documentation',
      searchByServices: 'Search by service',
      closeSearch: 'Close search',
      openSearch: 'Open search'
    }
  },
  PriceSummary: {
    total: 'Total',
    vat: 'including VAT',
    pricePeriodYear: 'per year',
    pricePeriodMonth: 'per month',
    pricePeriodDay: 'per day',
    pricePeriodHour: 'per hour',
    pricePeriodMinute: 'per minute',
    price: 'Price',
    basePrice: 'Base price',
    discount: 'Discount',
    orderDetails: 'Order details',
    docsLink: 'More about tariffs and prices',
    dataError: 'Loading error',
    costLink: 'More about the cost'
  },
  PromoTagPredefined: {
    preview: 'Preview',
    tooltipService: 'The service is at the Preview stage. Quota increase is not available for it and the terms of billing, service SLA and support do not apply.',
    tooltipFunctional: 'The functionality is at the Preview stage. Billing, service SLA and support conditions do not apply to it.'
  },
  Quota: {
    peace: 'pcs.',
    created: 'Created',
    available: 'Available by quota',
    exceeded: 'Quota exhausted',
    increase: 'Increase',
    noData: 'Failed to load data',
    quotas: 'Quotas'
  },
  SiteHero: {
    Main: {
      platforms: 'Platforms'
    }
  },
  SiteSection: {
    Basic: {
      showMore: 'Show More'
    },
    PersonalManager: {
      title: 'More than regular support',
      subtitle: 'Full support for solving your problems and achieving business results',
      individualApproachTitle: 'Individual approach to every client',
      individualApproachDescription: 'Free consultation for your project. We will answer your questions and select the best solutions.',
      consultationButton: 'Get a consultation',
      allDaySupportTitle: 'On call 24/7',
      allDaySupportDescription: 'Free technical support 24/7, real people are always in touch.',
      argumentAmountOfExperts: '1,400+ experts in IT, cybersecurity and AI',
      argumentMethodologies: 'Proven methodologies and best practices for seamless cloud migration',
      argumentPersonalManager: 'Personal manager to assist with your tasks'
    }
  },
  Widget: {
    Solutions: {
      title: 'Quick start guides',
      link: 'View all'
    },
    Products: {
      title: 'Platform services'
    }
  }
};